import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import LoanRepaymentsAnalytics from '@/components/loans/LoanRepaymentsAnalytics';
import LoanRepaymentsRecords from '@/components/loans/LoanRepaymentsRecords';
import { Receipt } from 'lucide-react';

export default function LoanRepayments() {
    return (
        <div className="space-y-6 animate-fade-in px-4 sm:px-6 lg:px-8 pt-6">
            <div className="mb-8">
                <div className="flex items-center gap-3 mb-2">
                    <Receipt className="h-8 w-8" />
                    <h1 className="text-4xl font-semibold tracking-tight">Advance Repayments</h1>
                </div>
                <p className="text-muted-foreground">Track advance repayment records.</p>
            </div>

            <Tabs defaultValue="analytics" className="space-y-6">
                <TabsList>
                    <TabsTrigger value="analytics">Analytics</TabsTrigger>
                    <TabsTrigger value="records">Records</TabsTrigger>
                </TabsList>

                <TabsContent value="analytics">
                    <LoanRepaymentsAnalytics />
                </TabsContent>

                <TabsContent value="records">
                    <LoanRepaymentsRecords />
                </TabsContent>
            </Tabs>
        </div>
    );
}
